// extracted by mini-css-extract-plugin
export default {"form":"contacts-form_form__d0nsJ","form__title":"contacts-form_form__title__+3WTC","form__subtitle":"contacts-form_form__subtitle__VSm2A"};